<div id="fh5co-main">
  <div class="fh5co-tab-wrap">
      <ul class="fh5co-tab-menu">
          <li class="active"><a href="#" data-tab="1"><span class="icon icon-glass"></span><span class="menu-text">Profile</span></a></li>
          <li><a href="#" data-tab="2"><span class="icon icon-graduation-cap"></span><span class="menu-text">Education</span></a></li>
          <li><a href="#" data-tab="3"><span class="icon icon-black-tie"></span><span class="menu-text">Experience</span></a></li>
          <li><a href="#" data-tab="4" data-pie="yes"><span class="icon icon-fighter-jet"></span><span class="menu-text">Skills</span></a></li>
      </ul>
      <div class="fh5co-tab-content active" data-content="1">
          <div class="fh5co-content-inner text-center">
              <div class="row row-bottom-padded-sm">
                  <div class="col-md-12">
                      <figure>
                          <img src="assets/images/profile_img1.jpeg" alt="Karthick" style="max-width: 250px;">
                      </figure>
                      <h1>Karthick R</h1>
                      <p>I’m a Software Engineer and have in-depth knowledge in fields like Healthcare IT, 
                          Application Security, Digital Communication & Logistics Automation. 
                          I’ve analysed peculiar problems in these fields and have come up with optimal 
                          solutions applying my proficiency in several domains like critical system designs, 
                          end-to-end operations, supply chain applications, IOT apps, micro-service architectures and streaming platforms. </p>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-12 fh5co-counter">
                      <div class="fh5co-number fh5co-left">5+</div>
                      <div class="fh5co-text">
                          <h3 class="border-bottom">Years of experience in Application Engineering</h3>
                          <p>Latest technologies like .Net Core, Python, Angular, Serverless Design.</p>
                      </div>
                  </div>
              </div>
              <ul class="fh5co-social">
                  <li><a href="mailto:karthi2621@gmail.com"><i class="icon-envelope"></i></a></li>
                  <!-- <li><a href="#"><i class="icon-twitter"></i></a></li> -->
                  <!-- <li><a href="#"><i class="icon-instagram"></i></a></li> -->
                  <!-- <li><a href="#"><i class="icon-google"></i></a></li> -->
                  <li><a href="https://linkedin.com/in/karthickrajaram" target="_blank"><i class="icon-linkedin"></i></a></li>
              </ul>
          </div>
      </div>
      <div class="fh5co-tab-content" data-content="2">
          <div class="fh5co-content-inner">
              <div class="row">
                  <div class="col-md-12">
                      <p>Education is the passport to the future, for tomorrow belongs to those who prepare for it today.</p>
                      <p style="text-align: right;">-Malcolm X</p>

                      <div class="fh5co-feature">
                          <div class="fh5co-icon">
                              <i class="icon-graduation-cap"></i>
                          </div>
                          <div class="fh5co-text">
                              <h2>2018-2020</h2>
                              <p>Master in Bussiness Administration, Pondicherry University loyola collage, Chennai.</p>
                          </div>
                      </div>

                      <div class="fh5co-feature">
                          <div class="fh5co-icon">
                              <i class="icon-graduation-cap"></i>
                          </div>
                          <div class="fh5co-text">
                              <h2>2012-2016</h2>
                              <p>Communication Engineering, Peri Institute of Technology, Chennai.</p>
                          </div>
                      </div>

                  </div>
                  
              </div>
          </div>
      </div>
      <div class="fh5co-tab-content" data-content="3">
          <div class="fh5co-content-inner">
              <div class="row">
                  <div class="col-md-12">

                      <p>I have the privilege to work with these cool companies.</p>

                      <div class="fh5co-feature">
                          <div class="fh5co-icon">
                              <i class="icon-black-tie"></i>
                          </div>
                          <div class="fh5co-text">
                              <h3>ITech Solutions.</h3>
                              <p>small businesses to complex multi-platform systems for large corporate clients</p>
                          </div>
                      </div>

                      <div class="fh5co-feature">
                          <div class="fh5co-icon">
                              <i class="icon-black-tie"></i>
                          </div>
                          <div class="fh5co-text">
                              <h3>Colan Infotech.</h3>
                              <p>Service orientated, latest infrastructure techology fulfilled corporate</p>
                          </div>
                      </div>

                      <div class="fh5co-feature">
                          <div class="fh5co-icon">
                              <i class="icon-black-tie"></i>
                          </div>
                          <div class="fh5co-text">
                              <h3>Genix technologies Ltd.</h3>
                              <p>Health care IT Product play with latest technology and strong Security</p>
                          </div>
                      </div>

                  </div>
                  
              </div>
          </div>
      </div>
      <div class="fh5co-tab-content" data-content="4">
          <div class="fh5co-content-inner">
              <div class="row">
                  <div class="col-md-12">
                      <p>Excellence is not a skill, Its an Attitude</p>
                      <p style="text-align: right;">-Ralph Marston</p>
                  </div>
                  <div class="col-md-4 col-sm-6 col-xs-12 text-center">
                      <div class="chart" data-percent="95"><span><strong>.Net Core</strong>97%</span></div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-xs-12 text-center">
                      <div class="chart" data-percent="93"><span><strong>System Design</strong>93%</span></div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-xs-12 text-center">
                      <div class="chart" data-percent="90"><span><strong>IOT</strong>90%</span></div>
                  </div>

                  <div class="col-md-4 col-sm-6 col-xs-12 text-center">
                      <div class="chart" data-percent="89"><span><strong>Database</strong>89%</span></div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-xs-12 text-center">
                      <div class="chart" data-percent="85"><span><strong>Python</strong>85%</span></div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-xs-12 text-center">
                      <div class="chart" data-percent="90"><span><strong>Angular</strong>90%</span></div>
                  </div>

              </div>
          </div>
      </div>
  </div>
  <footer id="fh5co-footer">
      <div class="row">
          <div class="col-md-6 col-md-offset-3 text-center">
              <small>
                  &copy; 2021 Personal blog. All Rights Reserved.
              </small>
          </div>
      </div>
  </footer>
</div>
<router-outlet></router-outlet>
